import { convertToCm, convertToInches, convertToKg, convertToLb } from '@freight-cbm/shared-logic';
import { DimensionUnit, WeightUnit } from '@freight-cbm/shared-types';

interface DualUnitDisplayProps {
  type: 'dimension' | 'weight';
  value: number;
  unit: DimensionUnit | WeightUnit;
}

export function DualUnitDisplay({ type, value, unit }: DualUnitDisplayProps) {
  if (value <= 0) return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;

  let primary: string;
  let secondary: string;

  if (type === 'dimension') {
    const dimUnit = unit as DimensionUnit;
    const cm = convertToCm(value, dimUnit);
    const inches = convertToInches(value, dimUnit);
    if (cm >= 100) {
      primary = `${(cm / 100).toFixed(3)} m`;
    } else {
      primary = `${cm.toFixed(1)} cm`;
    }
    secondary = `${inches.toFixed(2)} in`;
  } else {
    const wUnit = unit as WeightUnit;
    const kg = convertToKg(value, wUnit);
    const lb = convertToLb(value, wUnit);
    primary = `${kg.toFixed(2)} kg`;
    secondary = `${lb.toFixed(2)} lb`;
  }

  return (
    <span>
      <strong>{primary}</strong>
      <span style={{ marginLeft: 'var(--space-1)', fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)' }}>
        ({secondary})
      </span>
    </span>
  );
}
